import React from "react"
import MoneyMattersIcon from "../icons/money-matters"
import NewsroomIcon from "../icons/newsroom"
import PogIcon from "../icons/pog"
import ProgramStoriesIcon from "../icons/program-stories"
import StudentLifeIcon from "../icons/student-life"
import WorkExperienceIcon from "../icons/work-experience"
import Link from "./link"

export default function CategoriesRow(): JSX.Element {
  return (
    <>
      <h3 className="text-3xl lg:text-2xl text-teal font-normal border-none">
        Our categories
      </h3>
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-12">
        <div className="col-span-1 text-center">
          <Link to="/blog/people-of-georgian">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <PogIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">
              People of Georgian
            </span>
          </Link>
        </div>
        <div className="col-span-1 text-center">
          <Link to="/blog/newsroom">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <NewsroomIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">Newsroom</span>
          </Link>
        </div>
        <div className="col-span-1 text-center">
          <Link to="/blog/student-life">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <StudentLifeIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">Student life</span>
          </Link>
        </div>
        <div className="col-span-1 text-center">
          <Link to="/blog/work-experience">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <WorkExperienceIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">
              Work experience
            </span>
          </Link>
        </div>
        <div className="col-span-1 text-center">
          <Link to="/blog/money-matters">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <MoneyMattersIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">Money matters</span>
          </Link>
        </div>
        <div className="col-span-1 text-center">
          <Link to="/blog/program-stories">
            <div className="w-full aspect-square p-8 bg-blue rounded-full mb-8 hover:vivid-gradient">
              <ProgramStoriesIcon className="w-full aspect-square text-white" />
            </div>
            <span className="text-black font-bold text-2xl">
              Program stories
            </span>
          </Link>
        </div>
      </div>
    </>
  )
}
